import styled from 'styled-components';
import { STRINGS } from 'config';
import complete from 'assets/primaryCare/icons/complete.svg';
import { ColumnDiv } from 'styles/elements/div';
import media from 'styles/media';

const CompleteEndstate = styled(ColumnDiv)`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
 -webkit-overflow-scrolling: touch;
  position: relative;
  ${props => props.theme.forceScrollBarStyles};
`;

const ReceivedHTML = styled.div`
  position: absolute;
  width: 100%;
  
  p, h2, ul, div {
    padding-left: 12%;
    padding-right: 12%;
    ${media.extraSmallAndBelow`
      padding-left: 15px;
      padding-right: 15px;
    `}
  }
  
  .suggestion-box {
    padding: 20px 40px;
    background: #d9f4ff;
    ${media.extraSmallAndBelow`
      padding: 15px 30px;
  `}
  }
  
  h1 {
    background: url(${STRINGS.S3_BUCKET}${complete}) no-repeat right 12% center / 90px;
    background-color: ${props => props.theme.completeColor};
    color: white;
    margin: 0;
    padding: 65px calc(12% + 110px) 25px 12%;
    line-height: 35px;
    font-size: 25px;
    font-family: sans-serif;
    font-weight: 300;
    ${media.extraSmallAndBelow`
      padding-left: 15px;
      padding-top: 50px;
      font-size: 20px;
      line-height: 30px;
      
      padding-right: 60px;
      background-size: 40px;
      background-position: calc(100% - 20px) 60px;
    `}
  }
  
  h2 {
    color: ${props => props.theme.headingColorPrimary};
    font-size: 22px;
    margin: 1em 0 1.5em;
    text-transform: none;
    line-height: unset;
  }
  
  ul {
    padding: 0 12% 0 calc(12% + 20px);
    list-style-type: disc;
    margin-bottom: 2em;
    ${media.extraSmallAndBelow`
      padding-left: 35px
    `}
    
    li {
      list-style-type: disc;
      line-height: 30px;
    }
  }
  
  p {
    line-height: 30px;
  }
`;

CompleteEndstate.Title = styled.h3``;
CompleteEndstate.Text = styled.p``;
CompleteEndstate.ReceivedHTML = ReceivedHTML;

export default CompleteEndstate;
